import HighlightsService from "../services/highlights.service";

export const highlights = {
  namespaced: true,
  actions: {
    getHighlightByContentTypeId({ }, contentTypeId) {
      return HighlightsService.getHighlightByContentTypeId(contentTypeId)
        .then(
          (resp) => Promise.resolve(resp),
          (error) => Promise.reject(error)
        )
        .catch((e) => Promise.reject(e));
    }
  },
  mutations: {},
  getters: {},
};

